import './style.css';

import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Dialog, Button } from '@economic/taco';

import ExternalLink from '../../../../../../shared/components/ExternalLink';
import MoneyflowActivationWidget from './MoneyflowActivationWidget';
import MoneyflowOfferDetails from './MoneyflowOfferDetails';
import { Column, Row } from '../../../../../../shared/components/Grid/Grid';
import { MoneyflowOfferOverviewResult } from '../../../../../../../types/internal-api';
import { PaymentBankAccount } from './types';
import { tBB, t } from '../../../../../../shared/components/l10n/l10n';

const INVOICE_TYPE = 3;

interface Props {
    open: boolean;
    hide: () => void;
    invoiceDraftId: number;
    offer: MoneyflowOfferOverviewResult;
    onToggle: (isToggled: boolean) => void;
    paymentBankAccount: PaymentBankAccount;
}

export default function MoneyflowReviewOfferDialogComponent({
    open,
    hide,
    paymentBankAccount,
    offer,
    onToggle,
    invoiceDraftId,
}: Props) {
    const { agreementUrl } = offer;
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const bookAndSend = () => {
        navigate(pathname + '#book-draft', { state: { draftId: invoiceDraftId, type: INVOICE_TYPE } });
    };

    return (
        <Dialog open={open} onClose={hide} size="md">
            <Dialog.Content aria-label={t('FORM_BOOKANDSEND_MONEYFLOW_REVIEW_OFFER_HEADER')}>
                <Dialog.Title>{t('FORM_BOOKANDSEND_MONEYFLOW_REVIEW_OFFER_HEADER')}</Dialog.Title>

                <Row>
                    <Column>
                        <div className="pt-12">{tBB('FORM_BOOKANDSEND_MONEYFLOW_REVIEWOFFER_EXPLANATION')}</div>
                    </Column>
                    <Column>
                        <div className="moneyflow__review-offer__amounts">
                            <MoneyflowOfferDetails showAgreementLink={false} data={offer} />
                            <p className="moneyflow__review-offer__amounts__bank-info">
                                {t('FORM_BOOKANDSEND_MONEYFLOW_REVIEWOFFER_BANKINFO', {
                                    BANK_REG_NO: paymentBankAccount.regNo,
                                    BANK_ACC_NO: paymentBankAccount.accountNo,
                                })}
                                <br />
                                <ExternalLink
                                    className="outline-none"
                                    href={
                                        agreementUrl
                                    }>{t`FORM_BOOKANDSEND_MONEYFLOW_REVIEWOFFER_AGREEMENT_LINK_TEXT`}</ExternalLink>
                            </p>
                        </div>
                        <MoneyflowActivationWidget offerToggled={offer.toggled} onToggle={onToggle} />
                    </Column>
                </Row>

                <Dialog.Footer>
                    <Button appearance="primary" onClick={bookAndSend} disabled={!offer.toggled}>
                        {t`FORM_BOOKANDSEND_MONEYFLOW_REVIEWOFFER_BOOK_AND_SEND`}
                    </Button>
                </Dialog.Footer>
            </Dialog.Content>
        </Dialog>
    );
}
